import layout from '@/views/layout/layout.vue'
const messageList = r => require.ensure([], () => r(require('@/views/wechatExcellent/message/list.vue')), 'group-wechatExcellent-message')

const wechatExcellentMessage = [
  {
    path: '/wechatExcellent/message',
    name: 'wechatExcellent-message',
    component: layout,
    redirect: '/wechatExcellent/message/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: messageList,
        name: 'wechatExcellent-message-list',
        meta: {
          displayName: '系统消息管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default wechatExcellentMessage



// WEBPACK FOOTER //
// ./src/router/wechatExcellent/message.js